<h3 fxLayoutAlign="center">Inserir observação</h3>
<form [formGroup]="formGroup">
    <div fxLayout="column" fxLayoutAlign="center">
        <ng-container>
            <div fxLayoutGap="20px">
                <div>
                    <fd-input [parentForm]="formGroup" [field]="fields.observation"></fd-input>
                </div>
            </div>
        </ng-container>
    </div>
</form>
<div mat-dialog-actions>
    <div>
        <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"> </fd-button>
        <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="save()"> </fd-button>
    </div>
</div>
